export enum ErrorStatus {
  UNKNOWN = 'UNKNOWN',
  TIMEOUT = "TIMEOUT",
  _400 = '400',
  _401 = '401',
  _403 = '403',
  _404 = '404',
  _409 = '409',
  _500 = '500'
}

export enum UserErrorType {
  USER_NOT_CREATED = 'User not created',
  USER_NOT_FOUND = 'User not found'
}

export enum ClientErrorType {
  CLIENT_NOT_CREATED = 'Client not created',
  CLIENT_NOT_FOUND = 'Client not found'
}

export enum ContractErrorType {
  CONTRACT_NOT_CREATED = 'Contract not created',
  CONTRACT_NOT_FOUND = 'Contract not found'
}

export enum ScheduleErrorType {
  SCHEDULE_NOT_CREATED = 'Schedule not created',
  SCHEDULE_NOT_FOUND = 'Schedule not found'
}

export enum AdminErrorType {
  ADMIN_NOT_CREATED = 'Admin not created',
  ADMIN_NOT_FOUND = 'Admin not found'
}

export enum TechnicianErrorType {
  TECHNICIAN_NOT_CREATED = 'Technician not created',
  TECHNICIAN_NOT_FOUND = 'Technician not found'
}

export enum ServiceErrorType {
  SERVICE_NOT_CREATED = 'Service not created',
  SERVICE_NOT_FOUND = 'Service not found'
}

export enum AvailabilityErrorType {
  AVAILABILITY_NOT_CREATED = 'Availability not created',
  AVAILABILITY_NOT_FOUND = 'Availability not found'
}

export enum FirebaseErrorType {
  FIREBASE_NOT_CREATED = 'Firebase not created',
  FIREBASE_NOT_FOUND = 'Firebase not found'
}